import React, { useState, useEffect, useContext } from 'react';
import AccessThermScreen from '../../Components/AccessTherm/TermoPDF';
// import AtualizarPerfilScreen from "../../Components/AtualizarPerfil";
import { Spinner } from '../../Components/StyledComponent';
import { ContextGetData } from '../../services/getData';
import { getTermos } from '../../services/termo';
// import { ContextNotificacoes } from "../../services/notificacoes";
import { useHistory } from 'react-router-dom';
const AtualizarPerfil = () => {
  const [accessTerm, setAccessTerm] = useState(false);

  const [loading, setLoading] = useState(true);

  const [termosDeAcesso, setTermosDeAcesso] = useState([]);

  const [showAtualizarPerfilScreen, setShowAtualizarPerfilScreen] =
    useState(false);

  const { loadHomeInicial } = useContext(ContextGetData);

  const history = useHistory();

  useEffect(() => {
    let isMounted = true;

    async function load() {
      if (isMounted) {
        setLoading(true);
      }
      await loadArrayAcceptedAccessTerm();

      if (isMounted) {
        setLoading(false);
      }
    }
    load();
    return () => {
      isMounted = false;
    };
  }, []);

  async function loadArrayAcceptedAccessTerm() {
    const { aceiteTermos } = await loadHomeInicial();

    if (aceiteTermos?.length === 0) setShowAtualizarPerfilScreen(true);
    await functionGetTermos(aceiteTermos);
  }

  function getHigherTermoAceiteId(array) {
    let higherId = 0;

    array.forEach((item) => {
      if (item.TermoId > higherId) higherId = item.TermoId;
    });
    return higherId;
  }

  function getHigherActualTermoId(array) {
    let higherId = 0;

    array.forEach((item) => {
      if (item?.Id > higherId) higherId = item?.Id;
    });
    return higherId;
  }

  async function functionGetTermos(termosAceites) {
    let resultGetTermos = await getTermos();

    if (
      termosAceites != undefined &&
      (termosAceites?.length == 0 ||
        getHigherTermoAceiteId(termosAceites) <
          getHigherActualTermoId(resultGetTermos))
    ) {
      setAccessTerm(true);
      setTermosDeAcesso(resultGetTermos);
    } else {
      history.push('/interna');
    }
  }

  if (loading)
    return (
      <div style={{ width: '100%', height: '100vh' }} className='centralized'>
        <Spinner />
      </div>
    );

  return (
    accessTerm && (
      <AccessThermScreen
        termosDeAcesso={termosDeAcesso}
        readOnly={false}
        showAtualizarPerfilScreen={showAtualizarPerfilScreen}
      />
    )
  );
};

export default AtualizarPerfil;
